/**
 * 个人中心接口：侧边栏会话、订单、发票
 * 订阅/实名/用户资料复用 user 下 service
 */
import request from '@/utils/request';
import {
  fetchSubscriptionStatus,
  parseTrialEndTimestamp,
} from '@/view/user/subscriptionService/subscriptionService';
import {
  fetchRealnameStatus,
  isRealnameVerified,
  REALNAME_STATUS,
} from '@/view/user/realname/realnameService';
import {
  refreshIndivSession,
  getIndivSidebarSnapshot,
} from '@/view/user/indivSession/indivSessionService';

export { fetchUserAccount, refreshUserAccount } from '@/view/user/userAccount/userAccountService';

const PAYMENT_API = '/api/user/api/payment';
const INVOICE_API = '/api/user/api/invoice';

function indivGet(url, params = {}) {
  return request.get(url, { params }).catch(() => null);
}

function indivPost(url, params = {}) {
  return request.post(url, null, { params });
}

export function fetchSidebarData(options = {}) {
  const { force = false } = options;
  return refreshIndivSession({ force }).then(() => getIndivSidebarSnapshot());
}

export function sidebarDataFromGlobalState() {
  return getIndivSidebarSnapshot();
}

export function refreshPersonalCenterSidebar(options = {}) {
  const { force = false } = options;
  return refreshIndivSession({ force }).then(() => getIndivSidebarSnapshot());
}

export {
  fetchSubscriptionStatus,
  parseTrialEndTimestamp,
  fetchRealnameStatus,
  isRealnameVerified,
  REALNAME_STATUS,
};

export function fetchOrderDetail(orderNo) {
  return indivGet(`${PAYMENT_API}/order/query`, { orderNo });
}

export function fetchOrderList() {
  return indivGet(`${PAYMENT_API}/order/list`, { size: 1000 }).then((data) => {
    if (Array.isArray(data)) return data;
    if (data && Array.isArray(data.list)) return data.list;
    return [];
  });
}

export function cancelOrder(orderId) {
  return indivPost(`${PAYMENT_API}/order/cancel`, { orderId });
}

export function fetchInvoiceList() {
  return indivGet(`${INVOICE_API}/list`).then((data) => {
    if (Array.isArray(data)) return data;
    if (data && Array.isArray(data.list)) return data.list;
    return [];
  });
}

export function checkInvoiceEligible(orderId) {
  return indivGet(`${INVOICE_API}/check_eligible`, { orderId });
}



// WEBPACK FOOTER //
// ./src/view/client/personal-center/api.js